/**
 * Pages store
 */
import { getPersistedValue } from '@/helpers/store.js';

const maxAge = 28800000; // 8 hours [msec]

const initialState = () => ({
    pagesPublicOnly: {}, // from index '/'
    // pagesAll: {},
    timestamps: {}
});

const createStore = (Vue) => {

    const state = initialState;

    const getters = {
        getPagesPublicOnly (state) {
            return state.pagesPublicOnly;
        }

        // getPagesAll (state) {
        //     return state.pagesAll;
        // }
    };

    const actions = {
        async fetchPagesPublicOnly ({ commit, state }) {
            // check persisted localStorage
            const value = getPersistedValue(state, 'pagesPublicOnly', maxAge);
            if (value) {
                return Promise.resolve(value);
            }

            const params = {
                UseProfile: 'PublicOnly'
            };

            // fetch
            return new Promise((resolve, reject) => {
                Vue.prototype.$SVC.getPages('', params)
                    .then((response) => {
                        const pages = response && response.data;
                        commit('setPagesPublicOnly', pages);
                        resolve(pages);
                    })
                    .catch(reject);
            });
        }

        // svc/pages for "All" UseProfile are deprecated
        // async fetchPagesAll ({ commit, state }) {
        //     // check persisted localStorage
        //     const value = getPersistedValue(state, 'pagesAll', maxAge);
        //     if (value) {
        //         return Promise.resolve(value);
        //     }

        //     const params = {
        //         UseProfile: 'All'
        //     };

        //     // fetch
        //     return new Promise((resolve, reject) => {
        //         Vue.prototype.$SVC.getPages('', params)
        //             .then((response) => {
        //                 const pages = response && response.data;
        //                 commit('setPagesAll', pages);
        //                 resolve(pages);
        //             })
        //             .catch(reject);
        //     });
        // }
    };

    const mutations = {
        RESET (state) {
            const newState = initialState();
            Object.keys(newState).forEach((key) => {
                state[key] = newState[key];
            });
        },

        setPagesPublicOnly (state, value) {
            state.pagesPublicOnly = value || {};
            state.timestamps.pagesPublicOnly = new Date();
        }

        // setPagesAll (state, value) {
        //     state.pagesAll = value || {};
        //     state.timestamps.pagesAll = new Date();
        // }
    };

    return {
        namespaced: true,
        state,
        getters,
        actions,
        mutations
    };
};

export default app => createStore(app);
